export default {
    appearDuration: 300,
    appearDurationFinal: 1000,
    selector: 'img[width][height][alt]:not([alt=""])',
}
